import { render, staticRenderFns } from "./NewCarsInStock.vue?vue&type=template&id=3f50ed65&scoped=true"
import script from "./NewCarsInStock.vue?vue&type=script&lang=js"
export * from "./NewCarsInStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50ed65",
  null
  
)

export default component.exports